import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { HttpUtilityService } from "./http-utility.service";
import { GlobalFilterService } from "./global-filter.service";
import {
  LimitedResult,
  AuditSpecialist,
  PrimeNgListItem,
  Pagination,
  ILimitedResult,
} from "../models";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { BusinessResponse } from "src/app/models/businessResponse";
@Injectable({
  providedIn: "root",
})
export class AuditSpecialistService {
  private readonly base_url = `${environment.auditApiRoot.url}/clients`;
  constructor(
    private http: HttpClient,
    private httpUtility: HttpUtilityService,
    private globalFilterService: GlobalFilterService
  ) {}
  public async getAuditSpecialists(): Promise<LimitedResult<AuditSpecialist>> {
    return await this.http
      .get<LimitedResult<AuditSpecialist>>(
        `${environment.auditApiRoot.url}/clients/${this.globalFilterService.selectedClientId}/AuditSpecialists`,
        { headers: this.httpUtility.getHeaders() }
      )
      .toPromise();
  }

  public getAuditSpecialistListItems(): Observable<PrimeNgListItem[]> {
    return this.http
      .get(
        `${environment.auditApiRoot.url}/clients/${this.globalFilterService.selectedClientId}/AuditSpecialists/?limit=${environment.defaultListLimit}`,
        { headers: this.httpUtility.getHeaders() }
      )
      .pipe(
        map((res) =>
          res["Items"].map(
            (item) => new PrimeNgListItem(item.Name, item.SpecialistId)
          )
        )
      );
  }

  public getAuditSpecialistsLimitedResult(
    pagination: Pagination
  ): Observable<ILimitedResult<AuditSpecialist>> {
    const params = pagination.buildSearchParams();
    return this.http.get<ILimitedResult<AuditSpecialist>>(
      `${this.base_url}/${this.globalFilterService.selectedClientId}/AuditSpecialists`,
      { params }
    );
  }

  public addAuditSpecialist(name: string): Observable<BusinessResponse> {
    const url = `${this.base_url}/${this.globalFilterService.selectedClientId}/AuditSpecialists`;
    return this.http.post<BusinessResponse>(url, { Name: name });
  }

  public updateAuditSpecialist(
    specialistId: number,
    name: string
  ): Observable<BusinessResponse> {
    const url = `${this.base_url}/${this.globalFilterService.selectedClientId}/AuditSpecialists`;
    return this.http.put<BusinessResponse>(url, {
      SpecialistId: specialistId,
      Name: name,
    });
  }

  public deleteAuditSpecialist(specialistId: number): Observable<Response> {
    const url = `${this.base_url}/${this.globalFilterService.selectedClientId}/AuditSpecialists/${specialistId}`;
    return this.http.delete<Response>(url);
  }
}
